﻿import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useAddSubscription = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addSubscriptionPlan, { loading, data }] = useMutation<any>(
    mutations.addSubscriptionPlan,
    {
      onCompleted: (response) => {
        if (response.addSubscriptionPlan?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    addSubscriptionPlan,
    loading,
    success,
    data,
    resetForm,
  };
};
